import { ServiceStoreConfig } from "../types/ServiceStoreTypes";

/**
 * Organization Data Module Service Stores
 */
export const organizationDataStores: ServiceStoreConfig[] = [
  {
    name: "list-tracker",
    options: { enableStorage: true, enableErrorNotifications: false },
  },
];